var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light app-bg all-wrapper",attrs:{"id":"app"}},[_c('div',{staticClass:"app-loading",staticStyle:{"display":"none"},attrs:{"id":"commonAjaxLoading"}},[_c('app-loading')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }